import MobileBottomPanel from '@ui/MobileBottomPanel/component'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'

import type { MobileBottomPanelType } from '@ui/MobileBottomPanel/component'

export interface SearchMobileRecapType {
  open: () => ReturnType<MobileBottomPanelType['toggle']>
}

export default (el: HTMLElement): SearchMobileRecapType | void => {
  const mobileBottomPanelEl = el.querySelector<HTMLElement>('.search-mobile-recap-panel')

  if (!mobileBottomPanelEl) {
    return
  }

  const mobileBottomPanel = MobileBottomPanel(mobileBottomPanelEl)

  el.addEventListener('click', () => {
    mobileBottomPanel.toggle()
  })

  ElementPropertiesManager.addProperty<SearchMobileRecapType>(el, 'searchMobileRecap', mobileBottomPanel)

  return {
    open: () => mobileBottomPanel.open(),
  }
}
